import Reveal from "./Reveal";

const SectionHeading = ({ eyebrow, title, subtitle, light = false, align = "center" }) => (
  <Reveal className={`mb-12 ${align === "center" ? "text-center mx-auto max-w-2xl" : "text-left"}`}>
    {eyebrow && (
      <span className="text-brand-gold font-semibold tracking-[0.2em] text-sm uppercase">
        {eyebrow}
      </span>
    )}
    <h2 className={`mt-2 text-4xl sm:text-5xl font-extrabold ${light ? "text-white" : "text-brand-dark"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-3 text-base sm:text-lg ${light ? "text-white/70" : "text-gray-500"}`}>
        {subtitle}
      </p>
    )}
  </Reveal>
);

export default SectionHeading;
